import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Close = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m5.625 5.343 14 14m0-14-14 14'
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.918 4.636a1 1 0 0 1 1.414 0l6.293 6.293 6.293-6.293a1 1 0 1 1 1.414 1.414l-6.293 6.293 6.293 6.293a1 1 0 0 1-1.414 1.414l-6.293-6.292-6.293 6.292a1 1 0 0 1-1.414-1.414l6.293-6.293L4.918 6.05a1 1 0 0 1 0-1.414'
        fill='currentColor'
      />
    )}
  </IconBase>
);
